export default __webpack_public_path__ + "static/media/longroad4.9c87098d.jpg";